import React from "react";
import { BetRunnerDetails } from "@tvg/ts-types/Bet";
// @ts-ignore
import RunnerNumber from "../../../_atom/RunnerNumber";
import {
  AlternateSeparator,
  AlternateSeparatorContainer,
  ListItem,
  ListItemWrapper,
  RunnerInfoContainer,
  RunnerName,
  RunnerNameContainer,
  SelectionList
} from "../styled-components";

interface AlternateRunnersProps {
  alternateRunners: BetRunnerDetails[];
  isBetsDetailedView: boolean;
  isDesktop: boolean;
  titles: string[];
  betStatusName: string;
  raceTypeCode: string;
  isActiveMultiRaceLegOver: boolean;
  isRaceOver: boolean;
  isUnknownWinnerStatus: boolean;
}

const AlternateRunners = ({
  alternateRunners,
  isBetsDetailedView,
  isDesktop,
  titles,
  betStatusName,
  raceTypeCode,
  isActiveMultiRaceLegOver,
  isRaceOver,
  isUnknownWinnerStatus
}: AlternateRunnersProps) => (
  <>
    {!isBetsDetailedView && (
      <AlternateSeparatorContainer>
        <AlternateSeparator />
      </AlternateSeparatorContainer>
    )}
    {alternateRunners?.map((runner: BetRunnerDetails, index: number) => (
      <SelectionList
        key={`selection-list--${index.toString()}`}
        isBetsDetailedView={isBetsDetailedView}
        isDesktop={isDesktop}
      >
        <ListItemWrapper isBetsDetailedView={isBetsDetailedView}>
          <ListItem
            data-qa-label="alternate-runnerNumber-ListItem"
            isBetsDetailedView={isBetsDetailedView}
          >
            <RunnerInfoContainer
              data-qa-label="alternate-saddle-row"
              isBetsDetailedView={isBetsDetailedView}
              cols={titles.length}
              betStatusName={betStatusName}
              isDesktop={isDesktop}
            >
              <RunnerNumber
                qaLabel={`saddle-container-${runner.runnerId}`}
                runnerId={runner.runnerId}
                saddleColor={runner.saddleColor}
                numberColor={runner.numberColor}
                raceTypeCode={raceTypeCode}
                isBetsStandalone
                isScratched={runner.isScratched}
                isActiveMultiRaceLegOver={
                  isActiveMultiRaceLegOver && !isBetsDetailedView
                }
                isRaceOver={isRaceOver}
                isBetsDetailedView={isBetsDetailedView}
                isUnknownWinnerStatus={isUnknownWinnerStatus}
                isAlternate
              />
              {isBetsDetailedView && (
                <RunnerNameContainer
                  data-qa-label="runnerName"
                  isUnknownWinnerStatus={isUnknownWinnerStatus}
                  isActiveMultiRaceLegOver={
                    isActiveMultiRaceLegOver && isBetsDetailedView
                  }
                >
                  <RunnerName
                    className="runner-name"
                    isScratched={runner?.isScratched ?? false}
                  >
                    {runner?.runnerName ?? ""}
                  </RunnerName>
                </RunnerNameContainer>
              )}
            </RunnerInfoContainer>
          </ListItem>
        </ListItemWrapper>
      </SelectionList>
    ))}
  </>
);

export default AlternateRunners;
